import { AppContext } from "App";
import { useContext } from "react";
import { FiAlignLeft, FiHome, FiShoppingCart, FiUser } from "react-icons/fi";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { geTotalCartAmount } from "slices/cart";
import './index.scss'

interface Props {
};

export function FloatingSection(props: Props) {
    const totalAmount = useSelector(geTotalCartAmount)
    const { handleCloseCart, handleCloseCategory } = useContext(AppContext)
    const navigate = useNavigate()


    return (
        <div className="main-bg floatingSection p-x mobile">
            <i className="floatingSection-icon" onClick={handleCloseCategory}>
                <FiAlignLeft />
            </i>
            <i className="floatingSection-icon">
                <Link to='/'>
                    <FiHome />
                </Link>
            </i>
            <i className="floatingSection-icon" onClick={handleCloseCart}>
                <FiShoppingCart />
                <span className="floatingSection-icon-badge float-top-right">{totalAmount}</span>
            </i>
            <Link to='/dashboard'>
                <i className="floatingSection-icon">
                    <FiUser />
                </i>
            </Link>
        </div>
    )
}
